/**
 * FormSeriesService
 * CRUD for form series (recurring forms; series-scoped uniqueness rules).
 * Route: forms/api/forms/series
 */
import { CrudService } from '../base/CrudService';
/** Service for FormSeries CRUD operations */
export class FormSeriesService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? FormSeriesService.DEFAULT_SERVICE_PATH,
            basePath: FormSeriesService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
FormSeriesService.DEFAULT_SERVICE_PATH = 'forms';
FormSeriesService.BASE_PATH = 'api/forms/series';
//# sourceMappingURL=FormSeriesService.js.map